import { CurrencyAmountInput } from '../../CurrencyAmountInput'

import * as styles from './MoneyInputControlContent.module.css'

function MoneyInputControlContent({
  className = styles.MoneyInputControlContent,
  ...restProps
}) {
  return (
    <div className={className}>
      <CurrencyAmountInput {...restProps} />
    </div>
  )
}

export default MoneyInputControlContent
